module.exports = __webpack_public_path__ + "73bc48b82b410dc2c0a7e4fd31fc017a.pdf";